import React from 'react';
import HydrocarbonCondensatTable from './HydrocarbonCondensatTable';

const HydrocarbonCondensat = ({ refreshTrigger }) => (
  <HydrocarbonCondensatTable refreshTrigger={refreshTrigger} />
);

export default HydrocarbonCondensat;
